import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timeAgo',
    standalone: true
})
export class TimeAgoPipe implements PipeTransform {
    transform(value: Date | string | null, isUTC = false): string {
        const now = new Date();
        let returnString = '';

        if (value === null || value === '') {
            return '';
        }

        if (isUTC && value instanceof Date) {
            value = value.toISOString();
        } else if (isUTC && typeof value === 'string' && !value.includes('Z')) {
            value = `${value}Z`;
        }

        const diff = Math.round(now.getTime() - new Date(value).getTime());

        if (diff < 1000 * 90) {
            returnString = 'Just now';
        } else if (diff < 1000 * 3600) {
            // Anything less than 2 minutes is "Just now", so can't have 1 minutes ago
            returnString = `${Math.round(diff / (1000 * 60))} minutes ago`;
        } else if (diff < 1000 * 3600 * 24) {
            const hours = Math.round(diff / (1000 * 3600));
            returnString = `${hours} ${hours > 1 ? 'hours' : 'hour'} ago`;
        } else if (diff < 1000 * 3600 * 24 * 7) {
            const days = Math.round(diff / (1000 * 3600 * 24));
            returnString = `${days} ${days > 1 ? 'days' : 'day'} ago`;
        } else if (diff < 1000 * 3600 * 24 * 30) {
            const weeks = Math.round(diff / (1000 * 3600 * 24 * 7));
            returnString = `${weeks} ${weeks > 1 ? 'weeks' : 'week'} ago`;
        } else if (diff < 1000 * 3600 * 24 * 30 * 12) {
            const months = Math.round(diff / (1000 * 3600 * 24 * 30));
            returnString = `${months} ${months > 1 ? 'months' : 'month'} ago`;
        } else if (diff < 1000 * 3600 * 24 * 30 * 12 * 25) {
            const years = Math.round(diff / (1000 * 3600 * 24 * 30 * 12));
            returnString = `${years} ${years > 1 ? 'years' : 'year'} ago`;
        } else {
            returnString = 'A long time ago';
        }

        return returnString;
    }
}
